import {styled} from "@mui/material/styles";
import {mobileThreshold} from "../../../../../../Constants/layoutValues";
import {cssVarColors} from "../../../../../../Constants";

export const ValuePropsItemsWrapper = styled('div')`
	padding-top: 2rem;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	flex-direction: row;
	@media (max-width: ${mobileThreshold}px)
	{
		flex-direction: column;
	};
`;

export const ValuePropsItemWrapper = styled('div')`
	display: flex;
	flex-direction: column;
	align-items: center;
	flex: 1 1 calc(33.333% - 3rem); // 3 per row, with more spacing room
	padding-left: 1.5rem;
	padding-right: 1.5rem;
	padding-bottom: 3rem;
	@media (max-width: ${mobileThreshold}px)
	{
		display: flex;
		flex-direction: column;
		margin-left: -1rem;
		margin-right: -1rem;
		padding-left: 1rem;
		padding-right: 1rem;
		padding-top: 1.5rem;
		padding-bottom: 2rem;
		:nth-of-type(even)
		{
			background-color: ${cssVarColors.surface};
		}
	};
`;

export const ImageWrapper = styled('div')`
	padding-right: .75rem;
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 1rem;
	font-size: 5rem;
	padding-bottom: .5rem;
`;

export const Image = styled('img')`
	max-width: 100%;
	max-height: 100%;
	@media (max-width: ${mobileThreshold}px)
	{
		font-size: 6rem;
	};
`;

export const TitleWrapper = styled('div')`
	display: flex;
	flex-direction: column;
	align-items: center;
	color: ${cssVarColors.highlight};
	padding-top: .5rem;
	padding-bottom: .5rem;
	font-size: 1.6rem;
`;


export const ContentWrapper = styled('div')`
	padding-top: .5rem;
	flex: 1;
	font-size: 1.2rem;
	line-height: 1.6;
`;

